import React, { Component } from "react";
import { Box } from "mineral-ui";
import { H2, P } from "../components/html";
import { parseLicense, timeRemaining } from "../license";

const renderLicense = license => (
  <span>
    licensed to <strong>{license.to}</strong>; license token will stop working
    on {new Date(license.exp).toISOString()} ({timeRemaining(license.exp)})
  </span>
);

class ValidatePage extends Component {
  state = {
    license: "",
  };

  handleChangeToken = e => {
    this.setState({ license: e.target.value || "" });
  };

  render() {
    let license;
    let error;
    try {
      license = parseLicense(this.state.license);
    } catch (e) {
      error = e;
    }
    const details = error ? (
      String(error.message)
    ) : license ? (
      renderLicense(license)
    ) : (
      <em>
        invalid license '<code>{this.state.license}</code>'
      </em>
    );
    return (
      <Box>
        <Box marginVertical="xl">
          <H2 align="center">License validator</H2>
        </Box>

        <Box marginTop="lg">
          <P>Enter your current license below to view its expiry date.</P>
          <P>
            <textarea
              style={{ width: "100%", height: "4em" }}
              value={this.state.license}
              onChange={this.handleChangeToken}
            />
          </P>
          <P>Details: {details}</P>
        </Box>
      </Box>
    );
  }
}
export default ValidatePage;
